/* ========================================================================
   Carousels
 ========================================================================== */

app.carousel = (function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-carousel]').forEach((section) => {
      initGeneric(section);
    });

    document.querySelectorAll('[data-hero-carousel]').forEach((section) => {
      initHeroCarousel(section);
    });

    document.querySelectorAll('[data-logo-carousel]').forEach((section) => {
      initLogoCarousel(section);
    });
  }

  function initGeneric(section) {
    const viewport = section.querySelector('[data-carousel-viewport]');
    const prevBtn = section.querySelector('[data-carousel-prev]');
    const nextBtn = section.querySelector('[data-carousel-next]');
    const items = section.querySelectorAll('[data-carousel-item]');

    //
    // Init carousel
    //

    let startIndex = 0;

    if (viewport.dataset.startIndex) {
      startIndex = parseInt(viewport.dataset.startIndex);
    }

    const carousel = new EmblaCarousel(viewport, {
      inViewThreshold: 0.1,
      align: 'start',
      containScroll: 'trimSnaps',
      startIndex: startIndex,
      breakpoints: {
        '(min-width: 992px)': { draggable: false },
      },
    });

    //
    // Event listeners
    //

    carousel.on('init', (event) => {
      app.embla.onInit(carousel);
    });

    carousel.on('reInit', (event) => {
      app.embla.onReInit(carousel);
    });

    carousel.on('select', (event) => {
      app.embla.onSelect(carousel);
    });

    carousel.on('settle', (event) => {
      app.embla.onSettle(carousel);
    });
  }

  function initHeroCarousel(section) {
    const viewport = section.querySelector('[data-carousel-viewport]');
    const items = section.querySelectorAll('[data-carousel-item]');
    const timerEl = section.querySelector('[data-hero-carousel-timer]');
    const speed = 7000;

    //
    // Init carousel
    //

    let startIndex = 0;

    if (viewport.dataset.startIndex) {
      startIndex = parseInt(viewport.dataset.startIndex);
    }

    const emblaOptions = {
      inViewThreshold: 0.1,
      align: 'start',
      containScroll: 'trimSnaps',
      loop: false,
      draggable: false,
      skipSnaps: false,
      watchResize: false,
    };

    const autoPlay = EmblaAutoplay(
      { delay: speed, stopOnInteraction: false, stopOnMouseEnter: false },
      (emblaRoot) => emblaRoot.parentElement
    );

    let carousel = new EmblaCarousel(viewport, emblaOptions, [autoPlay]);

    //
    // Event listeners
    //

    carousel.on('init', (event) => {
      app.embla.onInit(carousel);
      startHeroTimer(timerEl, speed);
    });

    carousel.on('resize', (event) => {
      viewport.parentElement.dataset.initialized = false;

      carousel.scrollTo(0);

      for (let i = 0; i < items.length; i++) {
        items[i].dataset.selected = i == 0 ? true : false;
      }

      carousel.reInit();
    });

    carousel.on('reInit', (event) => {
      app.embla.onReInit(carousel);
      startHeroTimer(timerEl, speed);
    });

    carousel.on('select', (event) => {
      const image = carousel
        .slideNodes()
        [carousel.selectedScrollSnap()].querySelector('[data-hero-carousel-image]:not(.lazyloaded)');

      if (image) {
        image.classList.add('lazyload');
      }

      app.embla.onSelect(carousel);
      startHeroTimer(timerEl, speed);
    });

    carousel.on('settle', (event) => {
      app.embla.onSettle(carousel);
    });
  }

  function startHeroTimer(timerEl, speed) {
    timerEl.style = '';

    setTimeout(() => {
      timerEl.style.transform = 'translateX(0)';
      timerEl.style.transitionDuration = `${speed - 300}ms`;
    }, 250);
  }

  function initLogoCarousel(section) {
    const viewport = section.querySelector('[data-carousel-viewport]');
    const items = section.querySelectorAll('[data-carousel-item]');

    //
    // Init carousels
    //

    const emblaOptions = {
      inViewThreshold: 0.1,
      align: 'start',
      containScroll: 'trimSnaps',
      loop: true,
      breakpoints: {
        '(min-width: 992px)': { draggable: false },
      },
    };

    const autoPlay = EmblaAutoplay(
      { delay: 3000, stopOnInteraction: false, stopOnMouseEnter: true },
      (emblaRoot) => emblaRoot.parentElement
    );

    const carousel = new EmblaCarousel(viewport, emblaOptions, [autoPlay]);

    //
    // Event listeners
    //

    carousel.on('init', (event) => {
      app.embla.onInit(carousel);
    });

    carousel.on('reInit', (event) => {
      app.embla.onReInit(carousel);
    });

    carousel.on('select', (event) => {
      app.embla.onSelect(carousel);
    });

    carousel.on('settle', (event) => {
      app.embla.onSettle(carousel);
    });
  }

  // Expose public functions and variables
  return {
    init: init,
    initGeneric: initGeneric,
  };
})();
